import { useState, useEffect } from "react";
import { Table, Button, Container, Alert, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function DeleteProduct() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllProducts();
  }, []);

  const fetchAllProducts = () => {
    setLoading(true);
    fetch("http://localhost:4000/products/all")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setLoading(false);
        Swal.fire("Error", "Failed to fetch products", "error");
      });
  };

  const handleDelete = (productId, productName) => {
    Swal.fire({
      title: "⚠️ PERMANENT DELETION",
      html: `
        <p>Are you absolutely sure you want to <strong>permanently delete</strong> "${productName}"?</p>
        <p style="color: red; font-weight: bold;">This action CANNOT be undone!</p>
        <p>The product will be completely removed from the database.</p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, DELETE PERMANENTLY!",
      cancelButtonText: "Cancel",
      focusCancel: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Second confirmation for extra safety
        Swal.fire({
          title: "Final Confirmation",
          text: "This is your last chance to cancel. Are you sure?",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "DELETE PERMANENTLY",
          cancelButtonText: "Cancel",
        }).then((finalResult) => {
          if (finalResult.isConfirmed) {
            fetch(`http://localhost:4000/products/${productId}`, {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
              .then((res) => res.json())
              .then((data) => {
                if (data === true) {
                  Swal.fire(
                    "Deleted!",
                    "Product has been permanently deleted.",
                    "success"
                  );
                  fetchAllProducts(); // Refresh the list
                } else {
                  Swal.fire("Error", "Failed to delete product", "error");
                }
              })
              .catch((error) => {
                console.error("Error deleting product:", error);
                Swal.fire("Error", "Failed to delete product", "error");
              });
          }
        });
      }
    });
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="text-danger">⚠️ Delete Products (Permanent)</h1>
        <Button variant="secondary" onClick={() => navigate("/admin")}>
          Back to Admin
        </Button>
      </div>

      <Alert variant="danger">
        <Alert.Heading>⚠️ DANGER ZONE</Alert.Heading>
        <p>
          <strong>WARNING:</strong> This page allows you to permanently delete products from the database.
          This action is <strong>irreversible</strong> and cannot be undone.
        </p>
        <hr />
        <p className="mb-0">
          Consider using the "Deactivate" function instead if you want to temporarily hide products.
        </p>
      </Alert>

      {loading ? (
        <Alert variant="info">Loading products...</Alert>
      ) : products.length === 0 ? (
        <Alert variant="warning">No products found.</Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Description</th>
              <th>Price</th>
              <th>Status</th>
              <th>Created On</th>
              <th>Danger Zone</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product._id}>
                <td>{product.name}</td>
                <td>{product.description}</td>
                <td>₱{product.price}</td>
                <td>
                  <Badge bg={product.isActive ? "success" : "secondary"}>
                    {product.isActive ? "Active" : "Inactive"}
                  </Badge>
                </td>
                <td>{new Date(product.createdOn).toLocaleDateString()}</td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(product._id, product.name)}
                  >
                    🗑️ DELETE PERMANENTLY
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
}
